import React, { useEffect, useRef, useState } from 'react'
import { Provider } from 'react-redux'
import store from '~/data/store/store'

import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import MPZColorPicker from '~/Common-Objects/TemplateEditor/RightTools/ElementEditor/Components/ColourPicker'

const mpFontColorDropdown = ({
    color = '#000000',
    globalColours = [],
    favoriteColors = [],
    onChange = () => {},
    editorApp = null,
    elementsData = null
}) => {
    useEffect(() => {
        init()
    }, [])

    const [globalColoursState, setGlobalColoursState] = useState(globalColours)

    async function init() {
        const globalColoursFinal = DragDropFunctions.getTemplateColours(elementsData)
        setGlobalColoursState(globalColoursFinal)
    }

    return (
        <Provider store={store}>
            <div
                className='templateEditor-redactorplugins-mpColorPicker'
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                }}
                onMouseDown={(e) => {
                    e.preventDefault()
                }}
            >
                <MPZColorPicker
                    color={color}
                    onChange={onChange}
                    globalColours={globalColoursState}
                    favoriteColors={favoriteColors}
                    saveFaveColor={() => {}}
                    editorApp={editorApp}
                />
            </div>
        </Provider>
    )
}

export default mpFontColorDropdown
